import { gql } from '@apollo/client';

export const getAggregateStatistics = gql`
  query getAggregateStatistics(
    $timeZone: String!
    $fromTimestamp: String
    $toTimestamp: String
  ) {
    statistics: getAggregateStatistics(
      parameters: {
        timeZone: $timeZone
        fromTimestamp: $fromTimestamp
        toTimestamp: $toTimestamp
      }
    ) {
      newOnboardings
      totalSucceededOnboardings
      totalSucceededAuthentications
      conversionRate
      overallPercentage {
        percentages {
          status
          percentage
        }
      }
      byPeriodPercentage {
        percentages {
          fromTimestamp
          toTimestamp
          percentages {
            status
            value
          }
        }
      }
    }
  }
`;
